import ajax from "./ajax";

export function getKornitProfiles() {
  return ajax("/printing/kornit-profiles");
}

export function updateKornitProfiles(data) {
  return ajax("/printing/kornit-profiles", { method: "PUT", data });
}

export function listKornitSetups() {
  return ajax("/printing/kornit-setups");
}

export function uploadKornitSetups(files) {
  const form = new FormData();
  (files || []).forEach((file) => form.append("files", file));
  return ajax("/printing/kornit-setups/upload", {
    method: "POST",
    data: form,
    timeout: 120000,
  });
}

export function deleteKornitSetup(id) {
  return ajax(`/printing/kornit-setups/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}

/**
 * Resolve a hypothetical scan and return the exact file name / KSF pair Riverr
 * would drop, with per-token reasons. No file is written.
 */
export function testKornitScan(data) {
  return ajax("/printing/kornit-test-scan", { method: "POST", data });
}

// ── Decomposed model (kornitConfig) ──────────────────────────────────────────

export function getKornitConfig() {
  return ajax("/printing/kornit-config");
}

export function updateKornitConfig(config) {
  return ajax("/printing/kornit-config", { method: "PUT", data: { config } });
}

/** Re-run importer rules on the saved config (collapse aliases, triage). */
export function reconcileKornitImport(facts = {}) {
  return ajax("/printing/kornit-config/reconcile", {
    method: "POST",
    data: { facts },
  });
}

export function getKornitReadiness() {
  return ajax("/printing/kornit-readiness");
}

/** Resolve a real scanned item for a machine (machine screen, §4). */
export function resolveKornitItem(query = {}) {
  return ajax("/printing/kornit-resolve", { query });
}

// ── SendEvents (§2/§4/§5) ─────────────────────────────────────────────────────

export function listKornitSendEvents(query = {}) {
  return ajax("/printing/kornit-send-events", { query });
}

export function createKornitSendEvent(data) {
  return ajax("/printing/kornit-send-events", { method: "POST", data });
}

export function reportKornitSendEvent(id, patch) {
  return ajax(`/printing/kornit-send-events/${encodeURIComponent(id)}`, {
    method: "PATCH",
    data: patch,
  });
}

// ── Station link (§5) ─────────────────────────────────────────────────────────

/** Admin: mint a station key for a machine. Returned in full exactly once. */
export function createKornitStationKey(machineId) {
  return ajax("/printing/kornit-station-key", {
    method: "POST",
    data: { machineId },
  });
}

/** Agent: mint a short-lived station token from the station key. */
export function mintKornitStationToken(stationKey) {
  return ajax("/printing/kornit-station/token", {
    method: "POST",
    data: { stationKey },
  });
}

/** Machine screen: exchange ?t= for a station session. */
export function exchangeKornitStationToken(token) {
  return ajax("/printing/kornit-station/session", {
    method: "POST",
    data: { token },
    skipAuth: true,
  });
}

/** Persist pallet/KST/placement for this print, or for the product. */
export function saveKornitOperatorOverride(data) {
  return ajax("/printing/kornit-operator-override", {
    method: "POST",
    data,
  });
}

/** Operator: change this press's send mode from Print Screen. */
export function setKornitSendMode(data) {
  return ajax("/printing/kornit-send-mode", { method: "POST", data });
}

/** Mark / clear verifiedOn for a style on this machine. */
export function setKornitVerified(data) {
  return ajax("/printing/kornit-verified", { method: "POST", data });
}

export function clearKornitVerified(data) {
  return ajax("/printing/kornit-verified", {
    method: "POST",
    data: { ...data, verified: false },
  });
}
